/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthd,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthdFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthdFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthdToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthd';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfo
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfo {
    /**
     * 
     * @type {Array<JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthd>}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfo
     */
    payMthdList?: Array<JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthd>;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfo
     */
    benepoUseFlag?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfo {
    return JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payMthdList': !exists(json, 'payMthdList') ? undefined : ((json['payMthdList'] as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthdFromJSON)),
        'benepoUseFlag': !exists(json, 'benepoUseFlag') ? undefined : json['benepoUseFlag'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payMthdList': value.payMthdList === undefined ? undefined : ((value.payMthdList as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthdToJSON)),
        'benepoUseFlag': value.benepoUseFlag,
    };
}

